export default "__VITE_ASSET__CPl6j3Rz__"